/**
 * THE STATE A MESSAGE LINK CARRIES (we-message-inline-actions D3, spec
 * `we-message-actions` "One address, one minimal URL, one opener") — the We tab
 * and the message's address, and nothing else. The live `?state=` is the whole
 * app state, so a link copied off it would hand the reader the copier's
 * filters, map and panels. This is the other half of the slot
 * `stores/weRouting.js#_buildCleanState` publishes: the same short keys, read
 * back by `_restoreFromDynamicState`.
 *
 * A thread message's card names the THREAD as its topic, so a known parent
 * makes the link `{t: parent, th: thread}`, which is how the thread arm lays the
 * two panels out. A card with no hub (a DM) states none.
 *
 * With only a `hubId`, the address is the hub itself: the post-sign-in landing
 * for an accepted hub invitation (`router/guestOnlyRoutes.js`).
 *
 * It imports nothing from the app, so the sign-in landing can read it without
 * reaching a workspace store (launch-marketing-pages design M2, the
 * `services/sessionToken.js` rule). `stores/weRouting.js` re-exports it.
 *
 * @param {Object} address
 * @param {number|string|null} address.hubId       the card's own hub
 * @param {number|string} [address.topicId]        the card's own topic
 * @param {number|string|null} address.threadParentId  that topic's parent channel, for a thread
 * @param {number|string} [address.messageId]
 * @returns {{secondaryPanel: {horizontalTab: "We", dynamicState: {we: Object}}}}
 */
export function messageLinkState({ hubId = null, topicId = null, threadParentId = null, messageId = null }) {
  const we = {};
  if (hubId != null) we.h = hubId;
  if (threadParentId != null) {
    we.t = threadParentId;
    we.th = topicId;
  } else if (topicId != null) {
    we.t = topicId;
  }
  if (messageId != null) we.m = messageId;

  return { secondaryPanel: { horizontalTab: "We", dynamicState: { we } } };
}
